import { Card } from '@breward/ui';
import {
  ScoresheetSchemaSection,
  ScoresheetSchemaSubsection,
} from '../../../../types/scoresheetSchemas';
import ScoresheetField from '../ScoresheetField/ScoresheetField';

interface ScoresheerSubsectionProps {
  values?: any;
  section: ScoresheetSchemaSection;
  subsection: ScoresheetSchemaSubsection;
}

const ScoresheetSubsection = ({
  values,
  section,
  subsection,
}: ScoresheerSubsectionProps) => {
  return (
    <Card title={subsection?.label} className="mb-4">
      <div className="col-span-12 flex flex-wrap items-center justify-between">
        {subsection?.fields?.map((field) => {
          return (
            <ScoresheetField
              key={field?.key}
              values={values}
              section={section}
              subsection={subsection}
              field={field}
            />
          );
        })}
      </div>
    </Card>
  );
};

export default ScoresheetSubsection;
